import React from 'react'

import DoctorHeader from '../../../components/doctor-header'
import DoctorSection from '../../../components/doctor-section'
import ConfirmContract from '../../../components/confirm-contract'
import DownloadButton from '../../../components/download-button'
import AddressInfo from '../../../components/adress-info'
import ListRenderer from '../../../components/list-renderer'
import AvailabilitySchedule from '../../../components/availability-schedule'
import Map from '../../../components/map'

import * as S from './styles'

import IProps from './props'

import LinkBuilder from '../../../helpers/helper-link-builder'

const Doctor = ({
  doctor, location, isContracted, handleContract,
}: IProps) => (
  <S.Container>
    <DoctorHeader
      name={`${doctor.firstName} ${doctor.lastName}`}
      email={doctor.email}
      number={doctor.phone}
      chatId={doctor.chatId}
      isContracted={isContracted}
      handleContract={handleContract}
    />
    <S.Content>
      <DoctorSection title="Sobre">{doctor.about}</DoctorSection>
      <DoctorSection title="Endereço">
        <AddressInfo address={doctor.address} />
        <Map location={location} />
      </DoctorSection>

      <DoctorSection title="Especialidade">
        <ListRenderer
          items={doctor.specialties.map((specialty) => specialty.name)}
        />
      </DoctorSection>
      <DoctorSection title="Cidades que deseja trabalhar">
        <ListRenderer items={doctor.cities.map((city) => city.name)} />
      </DoctorSection>
      <DoctorSection title="Disponibilidade">
        <AvailabilitySchedule availability={doctor.availability} />
      </DoctorSection>
      <DoctorSection title="Locais em que está apto(a) a atuar">
        <ListRenderer items={doctor.workingPlaces} />
      </DoctorSection>
      <DoctorSection title="Currículo">
        <DownloadButton url={LinkBuilder.buildAssetsUrl(doctor.pdfUrl)} />
      </DoctorSection>
      <DoctorSection title="Observações">{doctor.observation}</DoctorSection>
      {!isContracted && (
        <ConfirmContract invertColor handleContract={handleContract} />
      )}
    </S.Content>
  </S.Container>
)

export default Doctor
